import { createReducer, on } from "@ngrx/store";
import { AssessmentProfileState, initialAssessmentProfileState } from "./assessment-profile.state";
import { GetAssessmentProfile, GetAssessmentProfileError, GetAssessmentProfileSuccess, ResetGetAssessmentProfileState } from "./assessment-profile.actions";

export const AssessmentProfileReducers = createReducer(
  initialAssessmentProfileState,
  on(GetAssessmentProfile, (state): AssessmentProfileState => {
    return {
      ...state,
      assessmentProfileResult: null,
      assessmentProfileLoader: true,
    }
  }),
  on(GetAssessmentProfileSuccess, (state, action): AssessmentProfileState => {
    return {
      ...state,
      assessmentProfileResult: action.result,
      assessmentProfileLoader: false,
      assessmentProfileError: null,
    }
  }),
  on(GetAssessmentProfileError, (state, action): AssessmentProfileState => {
    return {
      ...state,
      assessmentProfileLoader: false,
      assessmentProfileError: action.error,
    }
  }),
  on(ResetGetAssessmentProfileState, (): AssessmentProfileState => {
    return {
      ...initialAssessmentProfileState,
    }
  }),
);